const logoBoxStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  ml: 1,
  position: 'relative' as 'relative',
};

const cardContentStyle = {
  p: 0,
  display: 'flex' as 'flex',
  flexDirection: 'column' as 'column',
  height: '100%',
};

export { logoBoxStyle, cardContentStyle };
